import React, { useEffect, useState } from 'react'
import styled, { useTheme } from 'styled-components';
import { StyledLabel } from '../../assets/styledComponents/Global';
import CircularProgress from './CircularProgress';
import ReloadIcon from '../../app/components/svgIcons/ReloadIcon';
import CheckIcon from '../../app/components/checkbox/CheckIcon';
import { getAll } from '../../app/services/indexedDBService';
import InfoIconOutline from '../../app/components/svgIcons/InfoIconOutline';
import DownloadIcon from '../../app/components/svgIcons/DownloadIcon';
import { useWindowSize } from '../../utils/helper';

const QuestionSideBar = ({ doneQuestions, questionsList, handleRetryUpload, videoProfileRes }) => {
    const theme = useTheme();
    const isSmallScreen = useWindowSize();
    const [progressMap, setProgressMap] = useState({});

    useEffect(() => {
        let interval = setInterval(async () => {
            try {
                const all = await getAll("uploads");

                // 👇 sirf current appId ke records filter karo
                const currentAppId = videoProfileRes?.videoApplication?.id;
                const filtered = all.filter(item => item.appId === currentAppId);

                const obj = {};
                filtered.forEach((item) => {
                    obj[item.id] = item;
                });

                setProgressMap(obj);
            } catch (err) {
                console.error('Failed to read upload progress from IndexedDB:', err);
            }
        }, 1000);

        return () => clearInterval(interval);
    }, [videoProfileRes]);



    return (
        <InterviewSideBar className='' isSmallScreen={isSmallScreen}>
            {!isSmallScreen && <div className='d-flex align-items-center justify-content-between mb-3 px-4'>

                <StyledLabel
                    size="18px"
                    fontWeight="600"
                    color={theme?.darktext}
                >
                    Attempted Questions
                </StyledLabel>
                <CircularProgress count={Object.values(progressMap).filter(item => item.progress === 100 || item.status === "uploaded").length} total={questionsList?.length} />

            </div>}
            <div className={`overflow-y-auto ${isSmallScreen ? 'px-2' : 'px-4'}`} style={{ height: 'calc(100vh - 280px)' }}>
                {doneQuestions?.map((data, index) => {
                    const status = progressMap[data.id]?.status;
                    const progress = progressMap[data.id]?.progress;
                    const fileSize = progressMap[data.id]?.fileSize;
                    const file = progressMap[data.id]?.file;


                    return (
                        <div className='d-flex flex-column mb-2 ' key={data + index}>
                            <div className='d-flex gap-2 mb-2' key={index + data}>
                                {progress !== 100 ? (
                                    <div
                                        className="d-flex align-items-center justify-content-center text-white"
                                        style={{
                                            borderRadius: "50%", width: "28px", height: "28px", minWidth: "28px", minHeight: "28px", flexShrink: 0, backgroundColor: theme?.secondary,
                                        }}>
                                        {String(index + 1).padStart(2, "0")}
                                    </div>
                                ) : (
                                    <div
                                        className="d-flex align-items-center justify-content-center text-white"
                                        style={{ borderRadius: "50%", width: "28px", height: "28px", minWidth: "28px", minHeight: "28px", flexShrink: 0, backgroundColor: "#2A7062", }}
                                    >
                                        <CheckIcon size="12px" color={theme?.white} />
                                    </div>
                                )}

                                <div className='d-flex flex-column w-100 gap-2 mb-2'>
                                    <StyledLabel
                                        size="14px" fontWeight="600" color={theme?.darktext}
                                    >
                                        {data.text}
                                    </StyledLabel>
                                    {progress !== undefined && status === "uploading" &&


                                        <div className="progress w-100" style={{ height: "6px" }}>
                                            <div
                                                className="progress-bar bg-success "
                                                role="progressbar"
                                                style={{ width: `${progress}%` }}
                                                ariaValuenow={progress}
                                                ariaValuemin={0}
                                                ariaValuemax={100}
                                            >


                                            </div>

                                        </div>
                                    }
                                    {progress !== undefined && status === "uploading" && <div className='d-flex align-items center justify-content-between mb-3'>
                                        <StyledLabel size='10px' color={theme?.subText}>
                                            {fileSize}
                                        </StyledLabel>
                                        <StyledLabel className='font-fredoka fw-normal' size='10px' color={theme?.subText}>
                                            {progress}% done
                                        </StyledLabel>
                                    </div>
                                    }
                                    {status === "uploaded" && (
                                        <div className='d-flex justify-content-between gap-2'>


                                            <span className="badge text-white p-2 w-auto" style={{ background: '#367ECA' }}>Answer Uploaded</span>
                                            <a className='cursor-pointer' href={file.url}
                                                download={`answer-q${index + 1}.webm`}>
                                                <DownloadIcon />
                                            </a>
                                        </div>
                                    )}

                                    {status === "failed" && (
                                        <div className='d-flex justify-content-start gap-2'>

                                            <span
                                                className="badge rounded d-flex align-items-center gap-1"
                                                style={{ background: '#E05555', padding: '2px 8px', fontSize: '12px' }}
                                            >
                                                <InfoIconOutline color="white" />
                                                Uploading Failed
                                            </span>

                                            <div
                                                role="button"
                                                className="d-flex align-items-center justify-content-center bg-body"
                                                style={{ width: '32px', height: '32px', borderRadius: '50%', cursor: 'pointer' }}
                                                onClick={() => handleRetryUpload(data?.id)}
                                                onKeyPress={(e) => { if (e.key === 'Enter') handleRetryUpload(data?.id); }}
                                                tabIndex={0}
                                            >
                                                <ReloadIcon />
                                            </div>
                                        </div>
                                    )}
                                </div>

                            </div>

                        </div>
                    )
                })}
            </div>
        </InterviewSideBar>
    )
}

export default QuestionSideBar

const InterviewSideBar = styled.div`
width:${({ isSmallScreen }) => isSmallScreen ? '100%' : "400px"};
gap: 10px;
height:100%;
opacity: 1;
border-radius: 10px;
padding-top:${({ isSmallScreen }) => isSmallScreen ? '0px' : '25px'};
// padding-right: 20px;
padding-bottom: 32px;
// padding-left: 20px;
background: #FFFFFF;
margin:${({ isSmallScreen }) => isSmallScreen ? '0px' : '10px'};

  `;